import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BasicModal from 'components/organisms/Modal/Basic';
import BasicModalHeader from 'components/molecules/Modal/Header';
import BasicModalSection from 'components/molecules/Modal/Section';
import BasicModalFooter from 'components/molecules/Modal/Footer';
import { post } from 'axios';

const UploadModal = (props) => {
  const { handleToggleModal, isOpen } = props;
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState(false);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
  }, []);

  const handleModalClose = () => {
    handleToggleModal(false);
  };

  const handleFileInput = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handlePost = () => {
    const url = '/api/manage/sales/postpay/upload';
    const formData = new FormData();
    formData.append('file', selectedFile);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    post(url, formData, config)
      .then((response) => {
        const { data } = response;
        alert(data.message);
        handleModalClose();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <BasicModal open={isOpen}>
        <BasicModalHeader
          headerOpen={true}
          headerTitle={t('후불내역등록')}
          closeBtn
          closeOnClick={handleModalClose}
        ></BasicModalHeader>
        <BasicModalSection>
          <div>
            <input
              type="file"
              name="file"
              onChange={(e) => handleFileInput(e)}
            />
          </div>
        </BasicModalSection>
        <BasicModalFooter
          confirmOnClick={handlePost}
          cancelOnClick={handleModalClose}
          confirmBtnOpen={true}
          confirmBtnTitle={t('확인')}
          cancelBtnOpen={true}
          cancelBtnTitle={t('취소')}
        />
      </BasicModal>
    </>
  );
};
export default UploadModal;
